import { DsdBetaToggleButton } from "./beta-toggle-button";
import { AppMainHeader } from "@/components/app-shell";
import type { DocumentSidebarToggleState } from "@/components/document-sidebar";
import { cn } from "@/lib/utils";
import { SubHeader } from "@/toggle-ui-kit/sub-header";
import {
  NOTE_REFERENCE_CELL_FILL,
  NOTE_REFERENCE_HARD_RULE_CELL_CLASS,
} from "@/utils/dsd-editor/note-reference-colors";
import { DSD_REVIEW_COPY } from "./copy";

export const DsdReviewHeader = ({
  sidebar,
  sidebarDisabled = false,
  unitDifferenceV2,
  onUnitDifferenceV2Change,
  hardRuleHighlight,
  onHardRuleHighlightChange,
}: {
  sidebar: DocumentSidebarToggleState["headerToggle"];
  /** 목차 사이드바가 아직 없는 분기(로딩·에러·빈 문서)에서 토글을 막는다 */
  sidebarDisabled?: boolean;
  /** 베타: 단수차이 V2 — 켜면 report 를 unit_difference_v2 로 다시 조회 */
  unitDifferenceV2: boolean;
  onUnitDifferenceV2Change: (enabled: boolean) => void;
  /** 베타: 하드룰 연결 셀 빗금 — 켠 동안만 본문·주석매칭 표와 패널에 표시 */
  hardRuleHighlight: boolean;
  onHardRuleHighlightChange: (enabled: boolean) => void;
}) => (
  <AppMainHeader
    sidebar={{ ...sidebar, disabled: sidebarDisabled }}
    actions={
      <div className="flex items-center gap-2">
        <DsdBetaToggleButton
          pressed={hardRuleHighlight}
          onPressedChange={onHardRuleHighlightChange}
        >
          {/* 문서의 빗금 셀과 같은 클래스로 견본을 그린다 — 켜면 어떤 셀이 바뀌는지 버튼만 봐도 안다 */}
          <span
            aria-hidden
            className={cn(
              "mr-1.5 inline-block size-3.5 rounded-[3px] ring-1 ring-inset ring-line-normal",
              NOTE_REFERENCE_CELL_FILL.positive,
              NOTE_REFERENCE_HARD_RULE_CELL_CLASS,
            )}
          />
          {DSD_REVIEW_COPY.header.hardRuleHighlight}
        </DsdBetaToggleButton>
        <DsdBetaToggleButton
          pressed={unitDifferenceV2}
          onPressedChange={onUnitDifferenceV2Change}
        >
          단수차이 V2
        </DsdBetaToggleButton>
      </div>
    }
  />
);

export const DsdReviewDocumentTitle = ({ filename }: { filename?: string }) => (
  <SubHeader
    files={[{ name: filename ?? DSD_REVIEW_COPY.header.fallbackTitle }]}
  />
);
